import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import AllSetFigure from "../../../../../assets/images/payment-link/accountSet.png";

const AllSetStep = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <img src={AllSetFigure} width="106.939px" height="102.037px" />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <Typography
          component="h5"
          sx={{
            color: "var(--Gray-700, #344054)",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
          }}
        >
          {t("pages.payment.overview.v2.receivingDetailsPopUp.confirmationTitle")}
        </Typography>
        <Typography
          component="h5"
          sx={{
            color: "var(--Gray-600, #475467)",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
          }}
        >
          {t("pages.payment.overview.v2.receivingDetailsPopUp.confirmationDescription")}
        </Typography>
      </Box>
    </Box>
  );
};

export default AllSetStep;
